import { pushEvent } from '../../../client/data-layer';
import type { SIDEBAR_STATE } from '../constants';
import type { VIEWS } from '../components/sidebar-mobile/constants';

export const trackOpeningSidebar = (
  view: SIDEBAR_STATE | VIEWS,
  element = ''
) => {
  pushEvent('trackOpeningSidebar', {
    view,
    element,
  });
};

export const trackClosingSidebar = (
  view: SIDEBAR_STATE | VIEWS,
  element = ''
) => {
  pushEvent('trackClosingSidebar', {
    view,
    element,
  });
};

export const trackClickingSidebarList = () => {
  pushEvent('trackClickingSidebarList');
};

export const trackClickingSidebarListItem = (type: string) => {
  pushEvent('trackClickingSidebarListItem', { type });
};

export const trackClickingSidebarAlert = (type: string) => {
  pushEvent('trackClickingSidebarAlert', { type });
};

export const trackListItemChangingQuantity = (type: string) => {
  pushEvent('trackListItemChangingQuantity', { type });
};

export const trackSidebarDeletingAlert = (type: string) => {
  pushEvent('trackSidebarDeletingAlert', { type });
};

export const trackSidebarDeletingListItem = (type: string) => {
  pushEvent('trackSidebarDeletingListItem', { type });
};

export const trackSidebarCreateAlertFromListItem = () => {
  pushEvent('trackSidebarCreateAlertFromListItem');
};

export const trackSidebarAlertEdit = (type: string) => {
  pushEvent('trackSidebarAlertEdit', { type });
};

export const trackSidebarDragAndDrop = (view: string) => {
  pushEvent('trackSidebarDragAndDrop', { view });
};
